import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取广告组分页列表
 * @param data
 */
export const getAdGroupPage = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/adGroup/page',
    method: 'POST',
    data
  })
}

/**
 * 新增广告组
 * @param data
 */
export const addOrUpdateAdGroup = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/adGroup/addOrUpdate',
    method: 'POST',
    data
  })
}

/**
 * 获取广告组详情
 * @param id
 */
export const getAdGroupDetail = (id) => {
  return request({
    url: env.ferryUrl + `/advertising/adGroup/getAdGroupInfo/${id}`,
    method: 'GET'
  })
}

/**
 * 获取广告组明细
 */
export const getAdGroupDetailInfo = (id) => {
  return request({
    url: env.ferryUrl + `/advertising/adGroup/getAdGroupDetail/${id}`,
    method: 'GET'
  })
}

/**
 * 修改广告组状态
 * @param data
 */
export const changeAdGroupStatus = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/adGroup/operate',
    method: 'POST',
    data
  })
}

/**
 * 已启用状态更新接口
 */
export const adGroupUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/adGroup/adGroupUpdate',
    method: 'POST',
    data
  })
}

/**
 * 删除广告组
 * @param id
 */
// export const deleteAdGroup = (id) => {
//   return request({
//     url: env.ferryUrl + `/advertising/group/${id}`,
//     method: 'DELETE'
//   })
// }

/**
 * 获取广告组默认banner列表
 * @param adGroupId
 */
// export const getAdGroupDefaultBanners = (adGroupId) => {
//   return request({
//     url: env.ferryUrl + `/advertising/group/default-banners/${adGroupId}`,
//     method: 'GET'
//   })
// }
